import { PerformanceMarkName, PerformanceMeasureName } from "common-types";

export const PrometheusTrackerConfig: PrometheusPerformanceMarkMapping = {
  [PerformanceMarkName.AE_FIRST_LINE_EXEC]: {},
  [PerformanceMarkName.AE_AFTER_INIT_PLUGINS]: {},
  [PerformanceMarkName.AE_AFTER_GPT_WRAPPER_INIT]: {},
  [PerformanceMarkName.AE_AD_ENGINE_INIT]: {},
  [PerformanceMarkName.AE_ON_BIDDERS_INIT]: {},
  [PerformanceMarkName.AE_AUCTION_START]: {
    onlyFirstRender: true,
    duration: {
      start: PerformanceMarkName.AE_FIRST_LINE_EXEC,
      name: PerformanceMeasureName.AE_DURATION_TO_BID,
    },
  },
  [PerformanceMarkName.AE_CONFIG_CALLBACK_COMPLETE]: {
    duration: {
      start: PerformanceMarkName.AE_CONFIG_CALLBACK_STARTED,
      name: PerformanceMeasureName.AE_CONFIG_CALLBACK_DURATION,
    },
  },
  [PerformanceMarkName.AE_AUCTION_END]: {
    onlyFirstRender: true,
    duration: {
      start: PerformanceMarkName.AE_AUCTION_START,
      name: PerformanceMeasureName.AE_AUCTION_DURATION,
    },
  },
  [PerformanceMarkName.AE_BEFORE_FIRST_CALL_ADS_REQUEST]: {},
  [PerformanceMarkName.AE_GPT_SLOT_REQUESTED_INITIAL]: {
    slotName: "top_leaderboard",
  },
  [PerformanceMarkName.AE_GPT_SLOT_RESPONSE_RECEIVED_INITIAL]: {
    slotName: "top_leaderboard",
  },
  [PerformanceMarkName.AE_GPT_SLOT_RENDERED_ENDED_INITIAL]: {
    slotName: "top_leaderboard",
  },
  [PerformanceMarkName.AE_GPT_SLOT_SLOT_ONLOAD_INITIAL]: {
    slotName: "top_leaderboard",
  },
};
